<template>
  <div class="home-box">
    <Follow v-if="user && user.alertNotice" />
    <van-tabs class="my-tabs" v-model="active" sticky swipeable animated>
      <van-tab title="精选">
        <div class="my-swipe">
          <van-swipe :autoplay="3000" indicator-color="#FF4300">
            <van-swipe-item v-for="(item, index) in slides" :key="index"><van-image height="160px" radius="10px" :src="item.img" @click="toDetail(item)"/></van-swipe-item>
          </van-swipe>
        </div>
        <Course v-for="(unit, index) in units" :key="index" :title="unit.name" :courses="unit.subjects" :show-type="unit.displayType" :invitation-code="invitationCode"/>
        <van-divider>更多精彩·敬请期待</van-divider>
      </van-tab>

      <!-- 其他分类 -->
      <van-tab v-for="(category, index) in categories" :key="index" :title="category.name">
        <Course :courses="category.subjects" :invitation-code="invitationCode"/>
        <van-divider>更多精彩·敬请期待</van-divider>
      </van-tab>
    </van-tabs>
    <!-- 赚奖学金页菜单的提示说明 -->
    <div class="profit-tips" v-if="showProfitTips">
      <img class="profit-tips__bg" :src="require('@/assets/icons/profit-tips.png')" alt="">
      <div class="profit-tips__bd">
        <div class="profit-tips__text">孩子喜欢《{{userSubjects[0].subject.title}}》吗？推荐给好友，还可以赚奖学金哦~</div>
        <div class="profit-tips__btns">
          <span @click="showProfitTips=false">知道了</span>
          <span @click="toProfit" class="primary">去看看</span>
        </div>
      </div>
    </div>
    <!-- 底部导航菜单 -->
    <Tabbar v-if="user" :isDistributor="user.isDistributor" />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar'
import Course from '@/components/Course'
import Follow from '@/components/Follow'
import { getHomeData } from './query.gql'

export default {
  name: 'home',
  data() {
    return {
      user: '',
      active: 0,
      categories: [],
      units: [],
      userSubjects: [],
      showProfitTips: false,
      invitationCode: '',
      slides: []
    }
  },
  components: {
    Tabbar,
    Course,
    Follow
  },
  async mounted() {
    const { invitationCode } = this.$route.query
    this.invitationCode = invitationCode
    console.log(`invitationCode1 --${this.invitationCode}`)

    await this.weixinAuth()
    this.wechatShare({
      title: '明明城堡 | 给孩子最好的通识启蒙课，足不出户看世界！',
      imgUrl: 'https://mmcb-pub.oss-cn-hangzhou.aliyuncs.com/mmcb-logo.png',
      desc: '让知识陪孩子去远航！[明明城堡]',
      link: `${window.location.origin}/`
    })
    this.loadData()
  },
  methods: {
    loadData() {
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getHomeData,
        variables: { includeTrySubjects: false },
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.user = res.data.profile
        self.categories = res.data.categories
        self.units = res.data.units
        self.userSubjects = res.data.userSubjects
        self.showProfitTips = self.userSubjects.length > 0 && !self.user.isDistributor
        self.$toast.clear()
        // self.$zhuge.identify(self.user.id, {
        //   name: self.user.nickname,
        //   avatar: self.user.avatar
        // })
      }).catch(err => {
        console.error('请求getHomeData报错', err)
        self.$toast.fail('加载数据出错')
      })

      let slideUrl = 'https://mmcb-pub.oss-cn-hangzhou.aliyuncs.com/slides/prod.json'
      if (process.env.NODE_ENV !== 'production') {
        slideUrl = 'https://mmcb-pub.oss-cn-hangzhou.aliyuncs.com/slides/dev.json'
      }
      fetch(slideUrl).then(response => {
        return response.json()
      }).then(data => {
        self.slides = data
      }).catch(err => {
        console.log(err)
      })
    },
    toProfit() {
      this.$router.replace({
        name: 'profit'
      })
    },
    toDetail(item) {
      const self = this
      this.$router.push({
        name: 'subject',
        query: {
          id: item.id,
          invitationCode: self.invitationCode
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.home-box {
  background-color: #F6F6F6;
  .my-tabs {
    .my-swipe {
      position: relative;
      top: -15px;
      left: -15px;
      width: calc(100% + 30px);
      background-color: #FFFFFF;
      padding-bottom: 15px;

      .van-image {
        margin: 15px;
        margin-bottom: 0px;
      }
    }

    .van-tabs__line {
      display: none;
    }
    .van-tabs__wrap {
      .van-tab {
        font-size: 15px;
        color: #4d4d4d;
        span {
          display: inline;
        }
        &.van-tab--active {
          color: $primary;
          font-weight: bold;
          font-size: 19px;
          span {
            padding-bottom: 5px;
            border-bottom: 3px solid $primary;
          }
        }
      }
    }

    .van-tabs__content {
      margin-bottom: 55px;
      .van-tab__pane {
        padding: 15px;
      }
    }
  }
  // 底部分割线
  .van-divider {
    width: 80%;
    margin: auto;
    font-size: 13px;
    color: $dividerColor;
    border-color: $dividerColor;
    &:before {
      margin-right: 10px;
    }
    &:after {
      margin-left: 10px;
    }
  }
  // 赚奖学金页菜单的提示说明
  .profit-tips{
    width: 200px;
    position: fixed;
    bottom: 50px;
    right: 40px;
    .profit-tips__bg{
      width: 100%;
    }
    .profit-tips__bd{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      padding: 15px 20px;
      box-sizing: border-box;
      .profit-tips__text{
        font-size: 12px;
        font-weight: 500;
        color: #333;
        line-height: 18px;
      }
      .profit-tips__btns{
        display: flex;
        justify-content: space-around;
        padding-top: 8px;
        span{
          display: block;
          width: 60px;
          height: 25px;
          line-height: 25px;
          border-radius: 25px;
          border: 1px solid #999;
          font-size: 12px;
          color: #999;
          text-align: center;
          box-sizing: border-box;
          &.primary{
            color: #fff;
            background: #E27639;
            border-color: #E27639;
          }
        }
      }
    }
  }
}
</style>
